export default [
  {
    prop: 'month',
    label: '月份',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'channel_name',
    label: '签约主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'work_price',
    label: '消耗金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'zfb_price',
    label: '支付宝金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'wx_price',
    label: '微信金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'rate',
    label: '服务费率',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'service_price',
    label: '服务费',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'rcon_price',
    label: '待对账金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'start_day',
    minWidth: 200,
    label: '金额产生日期',
    tooltip: true
  },
  {
    prop: 'action',
    width: '120px',
    label: '操作'
  }
]
